const __WEBPACK_NAMESPACE_OBJECT__ = require("@cyntler/react-doc-viewer");